export const xCss = `
:root{
  --xp-bg:#fff;
  --xp-text:#171717;
  --xp-muted:#536471;
  --xp-border:#e5e7eb;
  --xp-soft:#f3f4f6;
  --xp-link:#1d9bf0;
}
.dark :root{
  --xp-bg:#000;
  --xp-text:#e5e7eb;
  --xp-muted:#8b98a5;
  --xp-border:#2a2a2a;
  --xp-soft:#0b0b0b;
  --xp-link:#78c3ff;
}
.xp-container{
  max-width: 672px;            /* match others */
  margin: 0 auto;
  padding: 24px 16px;
}
.xp-card{
  background: var(--xp-bg);
  border: 1px solid var(--xp-border);
  color: var(--xp-text);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.06);
  overflow: hidden;
}
/* Inside spacing */
.xp-article{
  /* keep your existing padding */
  max-width: 640px;            /* optional; prevents text hugging edges on very wide view */
  margin: 0 auto;
  padding: 12px 16px;
}

/* Optional: a subtle divider between text & actions if you want */
.xp-card .xp-divider{
  border-top: 1px solid var(--xp-border);
  margin: 0;                   /* inside the card */
}
.xp-root{background:var(--xp-bg);color:var(--xp-text);font-size:15px;line-height:1.33;}
.xp-divider{margin-left:-1px;margin-right:-1px;border-top:1px solid var(--xp-border);}

.xp-article{max-width:640px;margin:0 auto;padding:12px 16px;}
.xp-row{display:flex;gap:12px;}
.xp-avatar-link{flex:0 0 auto;}
.xp-avatar-wrap{width:40px;height:40px;border-radius:999px;overflow:hidden;background:#e5e7eb;}
.dark .xp-avatar-wrap{background:#1a1a1a;}
.xp-avatar{width:40px;height:40px;object-fit:cover;border-radius:999px;}

.xp-main{min-width:0;flex:1 1 auto;}

.xp-header{display:flex;align-items:center;gap:6px;}
.xp-name{font-weight:600;color:inherit;text-decoration:none;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.xp-name:hover{text-decoration:underline;}
.xp-verified{display:inline-flex;align-items:center;color:#1d9bf0;}
.xp-verified-icon{width:16px;height:16px;}
.xp-handle{color:var(--xp-muted);white-space:nowrap;max-width:100%;overflow:hidden;text-overflow:ellipsis;}
.xp-dot{color:var(--xp-muted);}
.xp-when{color:var(--xp-muted);white-space:nowrap;}
.xp-more{margin-left:auto;width:36px;height:36px;border-radius:999px;border:0;background:transparent;color:var(--xp-muted);cursor:pointer;}
.xp-more:hover{background:rgba(0,0,0,.05);}
.dark .xp-more:hover{background:rgba(255,255,255,.08);}
.xp-more-icon{width:20px;height:20px;fill:currentColor;}

.xp-body{margin-top:4px;white-space:pre-wrap;word-break:break-word;}
.xp-link{color:var(--xp-link);text-decoration:underline;word-break:break-all;}

.xp-tags{margin-top:4px;color:#6b7280;display:flex;gap:6px 8px;flex-wrap:wrap;font-size:14px;}
.dark .xp-tags{color:#9ca3af;}
.xp-tag{word-break:break-all;}

.xp-link-line{padding:6px 0 0 0;}
.xp-media-card{margin-top:12px;border:1px solid var(--xp-border);border-radius:16px;overflow:hidden;}
.xp-media-anchor{display:block;text-decoration:none;color:inherit;}
/* 16:9 box */
.xp-media-ratio{position:relative;width:100%;aspect-ratio:16/9;background:var(--xp-soft);}
.xp-media{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;}

.xp-meta{margin-top:10px;color:var(--xp-muted);font-size:14px;}

.xp-actions{margin-top:8px;display:flex;justify-content:space-between;}
.xp-action{display:inline-flex;align-items:center;gap:6px;color:var(--xp-muted);background:transparent;border:0;padding:0;cursor:pointer;min-width:0;}
.xp-action-icon-wrap{width:36px;height:36px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;}
.xp-action-icon{width:24px;height:24px;fill:currentColor;}
.xp-action:hover .xp-action-icon-wrap{background:rgba(0,0,0,.05);}
.dark .xp-action:hover .xp-action-icon-wrap{background:rgba(255,255,255,.08);}
.xp-count{font-variant-numeric:tabular-nums;}
`;
